import { IOrderInputModel } from '@models/Order/IOrderInputModel';
import { IAddOrder, IOrderModel } from '@models/Order/IOrderModel';
import { handleError, handleResponse, MyAxios, priorityHandleError } from '@services/SettingAxios';
import { getAvailabilityTypePromise, getDeliveryTypePromise, getPaymentTypePromise } from '@services/ServiceOrder/TypePromise';
import { getPaymentTypes, OneClickOrderTypes, SelfDeliveryOrderTypes } from '@services/ServiceOrder/Api.dto';
class ServiceOrder {
  add(query: IOrderInputModel): Promise<IAddOrder> {
    return MyAxios.put('/api/order/add-order', query).then(handleResponse).catch(priorityHandleError);
  }

  // TODO : типы изменить.
  getOrder(id: number, hash: string, region: string): Promise<IOrderModel> {
    return MyAxios.get<IOrderModel>(`/api/order/get-order-v1/${id}.${hash}?regionId=${region}`).then(handleResponse).catch(handleError);
  }

  OneClickOrder(query: OneClickOrderTypes): Promise<IAddOrder> {
    return MyAxios.post('/api/order/1click', { ...query })
      .then(handleResponse)
      .catch(priorityHandleError);
  }

  SelfDeliveryOrder(query: SelfDeliveryOrderTypes): Promise<any> {
    return MyAxios.post('/api/order/self-delivery', { ...query })
      .then(handleResponse)
      .catch(priorityHandleError);
  }

  getDelivery(regionId: number): Promise<getDeliveryTypePromise> {
    return MyAxios.get(`/api/order/get-delivery-data?regionId=${regionId}`).then(handleResponse).catch(handleError);
  }

  getAvailability(regionId: number): Promise<getAvailabilityTypePromise> {
    return MyAxios.get(`api/order/get-delivery-variants-v2?regionId=${regionId}`).then(handleResponse).catch(handleError);
  }

  getPayment(query: getPaymentTypes): Promise<getPaymentTypePromise> {
    const { regionId, shopId, deliveryId } = query;
    return MyAxios.get(`/api/order/get-payment?regionId=${regionId}&deliveryId=${deliveryId}&shopId=${shopId || 0}`)
      .then(handleResponse)
      .catch(handleError);
  }
}

const serviceOrderInstance = new ServiceOrder();

export default serviceOrderInstance;
